import "../styles.css";
import axios from "axios";
import { toast } from "react-toastify";
import Form from "react-bootstrap/Form";
import { FaRedo } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import { Row, Card, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import InputGroup from "react-bootstrap/InputGroup";

import {
  VERIFY_OTP_URL,
  RESEND_OTP_URL,
  GENERATE_OTP_URL,
  VIEW_CERTIFICATE_URL,
  GET_CERTIFICATE_FOR_AIRTEL_URL,
} from "../../constants";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { ACROSS_LOGO, APB } from "../../assets";
import { getLanguage } from "../../utils/localization";
import LoadingSpinner from "../../components/GlobalLoading";
import { generateOtpURL } from "../../config/services";

function Certificate(props) {
  const [loading, setLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState(300);
  const [isUserOtp, setIsUserOtp] = useState("");
  const [isUserMobile, setIsUserMobile] = useState("");
  const [certificateList, setCertificateList] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [showNavigationRouter, setShowNavigationRouter] = useState(false);

  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          setIsButtonDisabled(false);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  // ****** Send Otp Mobile Api ******
  const sendOtpApi = (mobile) => {
    if (mobile?.length === 10) {
      setLoading(true);
      axios(`${GENERATE_OTP_URL}${mobile}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => {
          if (res?.status === 200) {
            toast.success(
              "OTP has been sent to your registered mobile number."
            );
            setLoading(false);
          }
          if (res?.status === 400) {
            toast.error(res?.data?.message);
            setLoading(false);
          }
          if (res?.status === 404) {
            toast.error(res?.data?.message);
            setLoading(false);
          }
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
        });
    }
  };

  // ****** Resend Otp Api ******
  const reSendOtpApi = (mobile) => {
    if (mobile?.length === 10) {
      setLoading(true);
      axios(`${RESEND_OTP_URL}${mobile}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => {
          if (res?.status === 200) {
            toast.success(
              "OTP has been re-sent to your registered mobile number"
            );
            setLoading(false);
          }
          if (res?.status === 400) {
            toast.error(res?.data?.message);
            setLoading(false);
          }
          if (res?.status === 404) {
            toast.error(res?.data?.message);
            setLoading(false);
          }
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
        });
    }
  };

  // ****** Validation ******
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isUserMobile) {
      setErrorMessage("Please enter your mobile number.");
      setShowError(true);
    } else if (isUserMobile?.length < 10) {
      setErrorMessage("Mobile number must be 10 digits long.");
      setShowError(true);
    } else if (!isUserOtp) {
      setErrorMessage("Please enter your otp.");
      setShowError(true);
    } else if (isUserOtp?.length < 6) {
      setErrorMessage("Otp must be 6 digits.");
      setShowError(true);
    } else {
      VerifyOtpApi();
      setShowError(false);
    }
  };
  const handleClose = () => {
    setShowError(false);
  };

  // ****** Verify Otp Api ******
  const VerifyOtpApi = () => {
    setLoading(true);
    axios(`${VERIFY_OTP_URL}${isUserMobile}&otp=${isUserOtp}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        console.log("149 ==== Verify Otp Res ====", res);
        if (res?.data?.verified === true) {
          getCertificateListApi(isUserMobile);
          toast.success("OTP successfully verified.");
          setLoading(false);
        }
        if (res?.data?.verified === false) {
          toast.error("The OTP you entered is incorrect. Please try again.");
          // toast.error(res?.data?.message);
          setLoading(false);
        }
        if (res?.status === 404) {
          toast.error(res?.data?.message);
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  // ****** Get Certificate List Api ******
  const getCertificateListApi = async (mobile) => {
    setLoading(true);

    axios(`${GET_CERTIFICATE_FOR_AIRTEL_URL}${mobile}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        console.log("162 ==== resp ====", res);
        if (res?.status === 200) {
          if (res?.data?.length > 0) {
            setCertificateList(res?.data);
            toast.success(res?.data?.message);
            setLoading(false);
          } else {
            toast.error(
              "Policy endorsement is pending due to incomplete details or incorrect video."
            );
            setShowNavigationRouter(true);
            setLoading(false);
          }
          // setCertificateList(res?.data);
          // toast.success(res?.data?.message);
          // setLoading(false);
        }
        if (res?.status === 400) {
          toast.error(res?.data?.message);
          setLoading(false);
        }
        if (res?.status === 404) {
          toast.error(res?.data?.message);
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  // ****** Open Url Api ******
  const onViewCertificate = (documentUrl) => {
    setLoading(true);

    axios(`${VIEW_CERTIFICATE_URL}${documentUrl}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        if (res?.status === 200) {
          window.open(res?.data, "_blank");
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((e) => {
        if (e?.response?.status === 400) {
          toast.error("Invalid Certificate Id. Please try again.");
          setLoading(false);
        }
        setLoading(false);
      });
  };

  // Function to Reset Inputs and Search Data
  const handleRefresh = () => {
    setIsUserMobile("");
    setIsUserOtp("");
    setCertificateList([]);
  };

  return (
    <React.Fragment>
      <div className="auth-wrapper text-center">
        <div className="auth-content">
          <Card className="borderless text-center" style={{ borderRadius: 8 }}>
            <Card.Body>
              <div className="mb-4 d-flex d-row">
                <div
                  style={{
                    width: "50%",
                    textAlign: "left",
                    justifyContent: "center",
                  }}
                >
                  <img src={APB} style={{ width: "70%" }} alt="" />
                </div>
                <div
                  style={{
                    width: "45%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    alt=""
                    src={ACROSS_LOGO}
                    style={{ width: "100%", marginTop: 35 }}
                  />
                </div>
              </div>

              <p
                className="text-danger mt-3 input-label-heading"
                style={{ fontSize: "1rem", textAlign: "left" }}
              >
                {getLanguage("VW_CRTFCT.LBL")}
              </p>

              <Form noValidate onSubmit={handleSubmit}>
                {/* ****** Mobile Container ****** */}
                <Row className="mb-3">
                  <Form.Group controlId="validationFormikUsername">
                    <Form.Label className="common-label">
                      {getLanguage("VW_CRTFCT.MBL")}
                    </Form.Label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        maxLength={10}
                        name="isUserMobile"
                        value={isUserMobile}
                        className="common-input"
                        aria-describedby="inputGroupPrepend"
                        placeholder={getLanguage("VW_CRTFCT.MBL_PLCHLDR")}
                        onChange={(e) => {
                          sendOtpApi(e?.target.value);
                          setIsUserMobile(e?.target.value);
                        }}
                      />
                    </InputGroup>
                  </Form.Group>
                </Row>

                {/* ****** Otp Container ****** */}
                <Row className="mb-3">
                  <Form.Group controlId="validationFormikUsername">
                    <Form.Label className="common-label">
                      {getLanguage("VW_CRTFCT.OTP")}
                    </Form.Label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        name="isUserOtp"
                        value={isUserOtp}
                        className="common-input"
                        aria-describedby="inputGroupPrepend"
                        placeholder={getLanguage("VW_CRTFCT.OTP_PLCHLDR")}
                        onChange={(e) => setIsUserOtp(e?.target.value)}
                      />
                    </InputGroup>
                  </Form.Group>
                </Row>

                {/* ****** Resend Otp Container ****** */}
                <Row className="mb-1">
                  {isButtonDisabled ? (
                    <p
                      style={{
                        textAlign: "right",
                        fontFamily: '"Poppins",serif',
                      }}
                    >
                      {getLanguage("VW_CRTFCT.RESND_IN")} 0
                      {formatTime(timeLeft)}
                    </p>
                  ) : (
                    <span
                      style={{
                        color: "#1e90ff",
                        cursor: "pointer",
                        textAlign: "right",
                        textDecoration: "underline",
                        fontFamily: '"Poppins",serif',
                      }}
                      onClick={(e) => {
                        setIsButtonDisabled(true);
                        setTimeLeft(300);
                        reSendOtpApi(isUserMobile);
                      }}
                    >
                      {getLanguage("VW_CRTFCT.RESND")}
                    </span>
                  )}
                </Row>

                {/* ****** Button Container ****** */}
                <Button
                  type="submit"
                  style={{ fontFamily: '"Poppins",serif' }}
                  className="w-100 mt-4 mb-4 fw-bold fs-5.5 p-3"
                >
                  {getLanguage("VW_CRTFCT.VW_CRTFCT_BTN")}
                </Button>

                {/* ****** Link Container ****** */}
                {showNavigationRouter && (
                  <Box className="mt-3">
                    <p>
                      <Link
                        to="/"
                        className="text-primary text-decoration-underline"
                        style={{
                          fontFamily: '"Poppins",serif',
                          fontSize: "1rem",
                        }}
                      >
                        {getLanguage("VW_CRTFCT.RE_UPLD_LBL")}
                      </Link>
                    </p>
                  </Box>
                )}

                {/* Refresh Button */}
                <div className="d-flex justify-content-center mt-3">
                  <Button
                    variant="secondary"
                    onClick={handleRefresh}
                    style={{ fontFamily: '"Poppins", serif' }}
                  >
                    <FaRedo className="me-2" />{" "}
                    {getLanguage("VW_CRTFCT.RFRS_BTN")}
                  </Button>
                </div>

                {/* ****** Certificate List Container ****** */}
                {certificateList?.length > 0 && (
                  <Row className="mb-3 p-3">
                    <table className="table table-bordered">
                      <thead className="thead-dark">
                        <tr>
                          <th>Sr</th>
                          <th>Certificate No</th>
                          <th>Customer Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {certificateList?.map((item, index) => {
                          return (
                            <tr key={item?.id}>
                              <td>{index + 1}</td>
                              <td>{item?.certificatesNumber}</td>
                              <td>{item?.customerName}</td>
                              <td>
                                <button
                                  title="View Details"
                                  className="btn btn-link"
                                  onClick={() =>
                                    onViewCertificate(item?.documentUrl)
                                  }
                                >
                                  <i className="fas fa-eye"></i>{" "}
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </Row>
                )}
              </Form>

              {/* Modal for Error Message */}
              <Modal
                centered
                show={showError}
                onHide={handleClose}
                dialogClassName="custom-modal p-4"
              >
                <Modal.Header className="border-0" closeButton>
                  <Modal.Title style={{ fontFamily: '"Poppins",serif' }}>
                    {getLanguage("MDL.WARN")}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="error-icon-container">
                    <img
                      alt="Error"
                      width="50"
                      height="50"
                      className="error-gif"
                      src={require("../../assets/gif/Warning.gif")}
                    />
                  </div>
                  <div style={{ color: "red", fontFamily: '"Poppins",serif' }}>
                    {errorMessage}
                  </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center border-0">
                  <Button
                    className="p-2 w-50"
                    variant="primary"
                    onClick={handleClose}
                    style={{ fontFamily: '"Poppins",serif' }}
                  >
                    {getLanguage("MDL.CLSE")}
                  </Button>
                </Modal.Footer>
              </Modal>
            </Card.Body>
          </Card>
        </div>
      </div>

      <LoadingSpinner open={loading} />
    </React.Fragment>
  );
}

export default Certificate;
